import * as React from 'react';
import { memo } from 'react';

import TextBox from 'components/molecules/TextBox';
import i18n from 'helper/i18n';
import { compileDynamicRoute } from 'helper/string';
import { CoachType } from 'types/coach';
import { PoolClusterType, PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

export type EmptyRendererProps = {
	selectedPool: PoolEnumType;
	selectedCluster: PoolClusterType;
	coach: string;
	total: number;
	doUnsetAllFilters: () => {};
};

const EmptyRenderer = ({ selectedPool, selectedCluster, coach, doUnsetAllFilters, total }: EmptyRendererProps) => {
	const reason = total > 0 ? 'filterReason' : 'dataReason'; // different text if filter is the reason or data
	const text = i18n(`react.impulsCoach.views.pools.${selectedPool}.empty.${reason}.${selectedCluster}.text`);
	const linkText = i18n(`react.impulsCoach.views.pools.${selectedPool}.empty.${reason}.${selectedCluster}.linkText`);

	const selectedPoolUrlPart = i18n(`react.impulsCoach.routes.pool.selectedPool.${selectedPool}.href`);
	const link = compileDynamicRoute(i18n('react.impulsCoach.routes.pool.cluster.href'), {
		cluster: i18n(`react.impulsCoach.routes.pool.cluster.all.href`),
		selectedPool: selectedPoolUrlPart,
	});

	return (
		<TextBox
			modifier="no-hits"
			text={text}
			coach={coach as CoachType}
			buttons={
				total > 0
					? [{ onClick: () => doUnsetAllFilters(), withoutIcon: true, modifier: 'base', title: linkText }]
					: [{ href: link, withoutIcon: true, modifier: 'base', title: linkText }]
			}
		/>
	);
};

export default memo(EmptyRenderer);
